export const TEXTS = {
  ADDED_TO_CART: 'Item added to bag',
  ADD_TO_CART_ERROR: 'Something went wrong. Make it yours by trying once again!',
  NON_CONFIGUREABLE_PRODUCT_SIZE: 'One Size',
};
